import { render } from "./BlogLeftSidebarPage.vue?vue&type=template&id=46948540&ts=true"
import script from "./BlogLeftSidebarPage.vue?vue&type=script&lang=ts"
export * from "./BlogLeftSidebarPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__